module.exports = __webpack_public_path__ + "img/1504381850.6866fa70.jpg";